import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ZiLibera, ZiLiberaUpdate } from './zile-libere.interface';

@Injectable({
    providedIn: 'root'
})
export class ZileLibereService {
    private basePath = environment.interop.basePath;

    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.zileLibere.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.zileLibere.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.zileLibere.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.zileLibere.delete;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.get(this.listUrl);
    }

    add(ziLibera: ZiLibera) {
        return this.http.post(this.storeUrl, ziLibera);
    }

    update(ziLibera: ZiLiberaUpdate) {
        return this.http.put(this.updateUrl, ziLibera);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }
}
